export const regionsCoordinates = (coordsArrayFromDb) => {
  if (coordsArrayFromDb) {
    return{
      type: "FeatureCollection",
      features: coordsArrayFromDb.map((coordsObj) => {
        return {
          type: "Feature",
          id: coordsObj.id+"",
          properties: { name: `${coordsObj.description}` },
          geometry: {
            type:(JSON.parse(coordsObj.coords.slice(0, -1))).geometry.type,
            coordinates:JSON.parse(coordsObj.coords.slice(0, -1)).geometry.coordinates
          },
        };
      }),
    };
  }
};
